import axios from "axios";
import { createStore } from "vuex";

export default createStore({
  state: {
    user: {},
    userDetails: {
      firstName: "",
      lastName: "",
    },
    userIsAuthenticated: false,
    userToken: "",
    userTokenStorageKeyName: "8bfa55fc69baee1047a4682d8da2bbd9UserToken",
    userRoutesGroupName: "user",
    userRoutesPathRoot: "/user/",
    userRoutesParentName: "PanelUser",

    // ------- API base url ------- //
    apiBaseUrlKeyName: "8bfa55fc69baee1047a4682d8da2bbd9ApiBaseUrl",
    apiBaseUrl: "",
    // ------- ------- //
  },
  getters: {},
  mutations: {
    // +++++++ USER STORE +++++++ +++++++ +++++++ +++++++ +++++++ +++++++ +++++++ //
    readUserToken(state) {
      let token = localStorage.getItem(state.userTokenStorageKeyName);
      state.userToken = token;
    },

    setUserToken(state, userToken) {
      if (userToken) {
        state.userIsAuthenticated = true;
        state.userToken = userToken;
        localStorage.setItem(state.userTokenStorageKeyName, userToken);
        axios.defaults.headers.common["x-token-user"] = userToken;
      } else {
        state.userIsAuthenticated = false;
        state.userToken = "";
        localStorage.removeItem(state.userTokenStorageKeyName);
        axios.defaults.headers.common["x-token-user"] = "";
      }
    },

    clearUserToken(state) {
      state.user={};state.userDetails={firstName:'',lastName:''};
      localStorage.removeItem('hz_user_cache');
      state.userIsAuthenticated = false;
      state.userToken = "";
      localStorage.removeItem(state.userTokenStorageKeyName);
      axios.defaults.headers.common["x-token-user"] = "";
    },
    setUserDetails(state, userDetails) {
      state.userDetails.firstName = userDetails.firstName;
      state.userDetails.lastName = userDetails.lastName;
    },
    setUser(state, user) {
      state.user = user || {};
      const firstName = user?.firstName || user?.firstname || user?.first_name || "";
      const lastName = user?.lastName || user?.lastname || user?.last_name || "";

      // propagate core profile fields
      state.userDetails.firstName = firstName;
      state.userDetails.lastName = lastName;
      // propagate contact + KYC snapshot for components that read from userDetails
      const kycStatus = user?.kycStatus || user?.kyc?.status || (user?.kyc_verified ? 'verified' : undefined);
      const kycVerified = (user?.kyc_verified === true) || (kycStatus === 'verified');
      state.userDetails.mobile = user?.mobile || user?.phone || state.userDetails.mobile;
      state.userDetails.kycStatus = kycStatus;
      state.userDetails.kyc_verified = kycVerified;
      state.userDetails.kyc = user?.kyc || state.userDetails.kyc;

      try {
        localStorage.setItem('hz_user_cache', JSON.stringify(user || {}));
      } catch (_) {}
    },
    // ####### END USER STORE ####### ####### ####### ####### ####### ####### ####### //
  },
  actions: {
    /** ------- USER ------- ------- ------- ------- ------- ------- ------- */
    execReadUserToken({ commit, state }) {
      commit("readUserToken");
    },

    execSetUserToken({ commit, state }) {
      commit("setUserToken");
    },

    execClearUserToken({ commit }) {
      commit("clearUserToken");
    },

    /** ------- END USER ------- ------- ------- ------- ------- ------- ------- */
  },
  modules: {},
});
